export default "__VITE_ASSET__D9y1Fgcw__"